// Saving a measure's status steps (measure-status.ts) on the device; they reach CRM through the outbox, offline included.
// Each is applied to the status stored on the device now, never one a screen worked out earlier.
import { patchFields, type DeviceRecord } from './device-db';
import { advanceTo, tapChanges, type MeasureStatus, type StatusTap } from './measure-status';
import { syncNow } from './outbox';

/** A step the app takes by itself, applied to the status stored now so it only ever moves forwards. */
export async function advanceMeasure(measure: DeviceRecord | undefined, target: MeasureStatus): Promise<void> {
  if (!measure || !advanceTo(measure.fields.hig_status, target)) return;
  await patchFields(measure.id, (stored) => advanceTo(stored.hig_status, target) ?? {});
  void syncNow();
}

/** A tap (Measuring done, Back to measuring, Assessment done): nothing when the stored status has moved on since. */
export async function saveStatusTap(measure: DeviceRecord, tap: StatusTap, today: string): Promise<void> {
  if (!tapChanges(tap, measure.fields.hig_status, today)) return;
  await patchFields(measure.id, (stored) => tapChanges(tap, stored.hig_status, today) ?? {});
  void syncNow();
}
